export const H2H = {
  TABS_INDEXES: {
    all: 0,
    homeAway: 1,
  },
  ANALYTICS: {
    TABS:{
      all: 'h2h-all',
      homeAway: 'h2h-home/away'
    }
  },
  ACTION_TYPES: {
    tabChangeH2h: 'tabChangeH2h',
    displayHandler: 'displayHandler'
  }
};
